import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@web-chat-core/ui-kit';
import { SIPCallDial } from './SIPCallDial';
import { CloseButton, Header, SIPCallLayout } from './view';

interface Props {
    onClose: () => void;
}

export const SIPCallBoard: React.FC<Props> = ({ onClose }) => {
    const { t } = useTranslation();

    return (
        <SIPCallLayout>
            <CloseButton onClick={onClose} size="small">
                <Icon icon="icClose" colorVariant="third" />
            </CloseButton>
            <Header variant="text2" colorVariant="base">
                {t('web_call_the_number')}
            </Header>
            <SIPCallDial onClose={onClose} />
        </SIPCallLayout>
    );
};
